import { Outlet } from 'react-router-dom';

import { BreadCrumb } from '@/components/breadcrumb/breadcrumb';
import { AppSidebar } from '@/components/sidebar/appSidebar';
import { SidebarInset } from '@/components/ui/sidebar';
import type { DashboardItem } from '@/models/dashboardItem';

interface DashboardProps {
  items?: DashboardItem[];
  menu: boolean;
}

const Dashboard = (props: DashboardProps) => {
  return (
    <>
      <AppSidebar items={props.items?.filter((item) => !item.disabled)} />
      <SidebarInset className="isolate">
        <BreadCrumb />
        <div className="layout overflow-x-auto @container/panel">
          <Outlet />
        </div>
      </SidebarInset>
    </>
  );
};

export default Dashboard;
